export default __webpack_public_path__ + "static/media/ListDots2.957e952a.svg";